import React, {useMemo, useState} from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations'
import GridBlock from 'components/GridBlock';
import {makeStyles} from "@material-ui/styles";
import BoldTypography from "components/BoldTypography";
import Button from "components/Button";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import moment from "moment";
import DateFormats from "constants/DateFormats";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import getObjectValue from "libs/getObjectValue";
import {getUserFullNameWithDeputy} from "libs/userNameGetter";

const useStyle = makeStyles(theme => ({
    column: {
        width: '30%'
    },
    change: {
        "&> td": {
            fontWeight: "bold",
            backgroundColor: theme.palette.primary.light
        }
    },
    noChanges: {
        textAlign: "center",
        marginTop: theme.spacing(2),
        fontSize: "1.2rem"
    },
    buttonShow: {
        position: "absolute",
        bottom: theme.spacing(2)
    }
}))

function HistoryElementComparator(
    {
        selectedElemLoaded,
        selectedElem,
        clearSelectedElem,
        propertyTransformer,
        customParamTransformer
    }) {
    const classes = useStyle();
    const [showTheSame, setShowTheSame] = useState(false)


    const content = useMemo(() => {
        const rows = [];
        const rowClasses = [];
        let changesCount = 0;
        let fieldsCount = 0;

        const {left, right} = selectedElemLoaded;
        const leftContent = left?.content || {};
        const rightContent = right.content;

        Object.keys(propertyTransformer).forEach((prop, i, arr) => {

            const tr = propertyTransformer[prop];
            const leftVal = tr.transform ? tr.transform(getObjectValue(tr.id, leftContent, null)) : getObjectValue(tr.id, leftContent, null)
            const rightVal = tr.transform ? tr.transform(getObjectValue(tr.id, rightContent, null)) : getObjectValue(tr.id, rightContent, null);
            const theSame = rightVal === leftVal;
            fieldsCount++;
            if (left === null || !theSame || showTheSame) {
                rows.push([tr.label, leftVal, rightVal])
                rowClasses.push(showTheSame && leftVal !== rightVal ? classes.change : undefined)
                if (!theSame)
                    changesCount++;
            }
        })
        return {rows, rowClasses, changesCount, fieldsCount, user: right.user, dateInserted: right.dateInserted}
    }, [selectedElemLoaded, showTheSame, propertyTransformer, classes.change])


    return (
        <GridBlock
            column
            alignItems='center'
        >
            <GridBlock justify="space-between">
                <>
                    <BoldTypography component='span'>{Tr('changing_person')}</BoldTypography>
                    <Typography
                        component='span'>{`: ${getUserFullNameWithDeputy(selectedElem.user)}`}
                    </Typography>
                    <br/>
                    <BoldTypography component='span'>{Tr('last_save_date')}</BoldTypography>
                    <Typography component='span'>{`: ${moment(selectedElem.dateInserted).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}`}</Typography>
                    {
                        !!customParamTransformer && Object.keys(customParamTransformer).map(x => (<>
                            <br/>
                            <BoldTypography component='span'>{customParamTransformer[x].label}</BoldTypography>
                            <Typography component='span'>{`: ${customParamTransformer[x].transform ? customParamTransformer[x].transform(selectedElem.params[x]) : (selectedElem.params[x] || null) }`}</Typography>
                        </>
                        ))

                    }
                </>
                <Button Icon={ArrowBackIosIcon} onClick={clearSelectedElem}>{Tr('back')}</Button>
            </GridBlock>


            <SimpleTable
                headers={
                    [
                        Tr('prop_name'),
                        Tr('change_before'),
                        Tr('change_after')
                    ]
                }
                items={content.rows}
                columnClasses={[
                    undefined,
                    classes.column,
                    classes.column,
                ]}
                rowClasses={content.rowClasses}
            />

            {!showTheSame && content.changesCount < content.fieldsCount && <Button
                className={classes.buttonShow}
                variant={'outlined'}
                size={'small'}
                onClick={() => setShowTheSame(true)}
            >
                {Tr('no_changes_fields_show')}
            </Button>}

            {
                content.changesCount === 0 && <BoldTypography className={classes.noChanges}>{Tr("no_changes")}</BoldTypography>
            }

        </GridBlock>
    )
}

HistoryElementComparator.propTypes = {
    classes: PropTypes.any,
}

export default HistoryElementComparator;
